var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.7 36.6-2.3-2.3L53.2 8.6l2.2 2.2-25.7 25.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 25.1h-3.4V11.4H38.9V8H56v17.1M47.4 56H13.1C10.3 56 8 53.7 8 50.9V16.6c0-2.8 2.3-5.1 5.1-5.1H32v3.4H13.1c-.9 0-1.7.8-1.7 1.7v34.3c0 .9.8 1.7 1.7 1.7h34.3c.9 0 1.7-.8 1.7-1.7V32h3.4v18.9c.1 2.8-2.2 5.1-5.1 5.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.2695ff0358bb2dfd51d3fbaaf512990e.svg";
export { ForwardRef as ReactComponent };